import styles from './Loader.module.css';
const Loader = () => {
    return (<div class={styles.loader}>
      <div class={styles.inner}/>
    </div>);
};
export default Loader;
